import React, { useEffect, useState } from "react";
import {
    Calendar,
    Clock,
    ArrowRight
} from "lucide-react";
import { Link } from "react-router-dom";


// const API_URL = "http://localhost:8483";
const API_URL = "https://www.ayushvatika.com";


interface Blog {

    id: number;

    title: string;

    slug: string;

    category?: string;

    excerpt?: string;

    featured_image?: string;

    image_alt?: string;

    published_at?: string;

    created_at: string;

    readTime?: string;
}


const DescriptionSection: React.FC = () => {

    const [blogs, setBlogs] =
        useState<Blog[]>([]);

    const [loading, setLoading] =
        useState(true);


    useEffect(() => {

        const fetchBlogs = async () => {

            try {

                const response =
                    await fetch(
                        `${API_URL}/api/blogs/latest`
                    );


                const data =
                    await response.json();


                if (data.success) {

                    setBlogs(
                        data.blogs
                    );

                }

            } catch (error) {

                console.error(
                    "Homepage blogs error:",
                    error
                );

            } finally {

                setLoading(false);

            }

        };


        fetchBlogs();

    }, []);


    return (

        <section
            className="
                bg-gradient-to-b
                from-[#f7fbf5]
                via-white
                to-white
                py-14
                sm:py-16
                px-4
                sm:px-6
                lg:px-8
            "
        >

            <div className="
                max-w-7xl
                mx-auto
            ">


                {/* HEADER */}

                <header
                    className="
                        text-center
                        max-w-3xl
                        mx-auto
                        mb-10
                    "
                >

                    <div
                        className="
                            text-green-700
                            text-xs
                            font-bold
                            uppercase
                            tracking-[0.18em]
                            mb-3
                        "
                    >
                        🌿 Ayurveda Blogs
                    </div>


                    <h2
                        className="
                            text-3xl
                            sm:text-4xl
                            lg:text-5xl
                            font-bold
                            text-[#19352a]
                        "
                    >
                        Latest from Our{" "}
                        <span className="text-green-700">
                            Ayurveda Blog
                        </span>
                    </h2>


                    <p
                        className="
                            text-gray-600
                            mt-4
                            leading-7
                        "
                    >
                        Explore Ayurvedic herbs, traditional
                        wellness, healthy lifestyle habits,
                        natural self-care and practical
                        Ayurveda tips.
                    </p>

                </header>



                {/* LOADING */}

                {loading && (

                    <div
                        className="
                            grid
                            grid-cols-1
                            md:grid-cols-2
                            lg:grid-cols-3
                            gap-6
                        "
                    >

                        {[1, 2, 3, 4, 5, 6].map(
                            item => (

                                <div
                                    key={item}
                                    className="
                                        h-[420px]
                                        bg-gray-100
                                        rounded-2xl
                                        animate-pulse
                                    "
                                />

                            )
                        )}

                    </div>

                )}



                {/* BLOGS */}

                {!loading &&
                    blogs.length > 0 && (

                        <div
                            className="
                                grid
                                grid-cols-1
                                md:grid-cols-2
                                lg:grid-cols-3
                                gap-6
                                lg:gap-7
                            "
                        >

                            {blogs.map(blog => (

                                <article
                                    key={blog.id}
                                    className="
                                        group
                                        bg-white
                                        rounded-2xl
                                        overflow-hidden
                                        border
                                        border-gray-200
                                        shadow-sm
                                        hover:shadow-xl
                                        hover:-translate-y-1
                                        transition-all
                                        duration-300
                                        flex
                                        flex-col
                                    "
                                >

                                    {/* IMAGE */}

                                    <Link
                                        to={`/blogs/${blog.slug}`}
                                        className="
                                            block
                                            relative
                                            aspect-[3/2]
                                            overflow-hidden
                                        "
                                    >

                                        <img
                                            src={
                                                blog.featured_image
                                                    ? `${API_URL}${blog.featured_image}`
                                                    : "/placeholder-blog.webp"
                                            }
                                            alt={
                                                blog.image_alt ||
                                                blog.title
                                            }
                                            loading="lazy"
                                            decoding="async"
                                            className="
                                                w-full
                                                h-full
                                                object-cover
                                                group-hover:scale-105
                                                transition-transform
                                                duration-700
                                            "
                                        />


                                        <span
                                            className="
                                                absolute
                                                top-4
                                                left-4
                                                bg-white/95
                                                text-green-800
                                                text-[10px]
                                                font-bold
                                                uppercase
                                                tracking-wider
                                                px-3
                                                py-1.5
                                                rounded-full
                                                shadow
                                            "
                                        >
                                            {blog.category ||
                                                "Ayurveda"}
                                        </span>

                                    </Link>



                                    {/* CONTENT */}

                                    <div
                                        className="
                                            p-5
                                            sm:p-6
                                            flex
                                            flex-col
                                            flex-grow
                                        "
                                    >

                                        <div
                                            className="
                                                flex
                                                items-center
                                                gap-4
                                                text-xs
                                                text-gray-400
                                                mb-3
                                            "
                                        >

                                            <span
                                                className="
                                                    flex
                                                    items-center
                                                    gap-1.5
                                                "
                                            >

                                                <Calendar
                                                    className="
                                                        w-3.5
                                                        h-3.5
                                                    "
                                                />

                                                {blog.published_at
                                                    ? new Date(
                                                        blog.published_at
                                                    ).toLocaleDateString(
                                                        "en-IN",
                                                        {
                                                            day: "numeric",
                                                            month: "short",
                                                            year: "numeric"
                                                        }
                                                    )
                                                    : ""}
                                            </span>


                                            <span
                                                className="
                                                    flex
                                                    items-center
                                                    gap-1.5
                                                "
                                            >

                                                <Clock
                                                    className="
                                                        w-3.5
                                                        h-3.5
                                                    "
                                                />

                                                6 min read

                                            </span>

                                        </div>


                                        <h3
                                            className="
                                                text-lg
                                                sm:text-xl
                                                font-bold
                                                text-[#19352a]
                                                leading-snug
                                                line-clamp-2
                                                group-hover:text-green-700
                                            "
                                        >

                                            <Link
                                                to={`/blogs/${blog.slug}`}
                                            >
                                                {blog.title}
                                            </Link>

                                        </h3>


                                        <p
                                            className="
                                                text-gray-600
                                                text-sm
                                                leading-6
                                                mt-3
                                                line-clamp-3
                                            "
                                        >
                                            {blog.excerpt}
                                        </p>


                                        <div
                                            className="
                                                mt-auto
                                                pt-5
                                                border-t
                                                border-gray-100
                                            "
                                        >

                                            <Link
                                                to={`/blogs/${blog.slug}`}
                                                className="
                                                    inline-flex
                                                    items-center
                                                    gap-2
                                                    text-green-700
                                                    font-bold
                                                    text-sm
                                                "
                                            >

                                                Read More

                                                <ArrowRight
                                                    className="
                                                        w-4
                                                        h-4
                                                        group-hover:translate-x-1
                                                        transition
                                                    "
                                                />

                                            </Link>

                                        </div>

                                    </div>

                                </article>

                            ))}

                        </div>

                    )}



                {/* NO BLOG */}

                {!loading &&
                    blogs.length === 0 && (

                        <div
                            className="
                                text-center
                                py-16
                                text-gray-500
                            "
                        >
                            No published blogs available.
                        </div>

                    )}



                {/* SEE MORE */}

                <div
                    className="
                        flex
                        justify-center
                        mt-10
                    "
                >

                    <Link
                        to="/blogs"
                        className="
                            inline-flex
                            items-center
                            gap-2
                            bg-green-700
                            hover:bg-green-800
                            text-white
                            px-7
                            py-3.5
                            rounded-full
                            font-semibold
                            text-sm
                            transition
                        "
                    >

                        See More Articles

                        <ArrowRight className="w-4 h-4" />

                    </Link>

                </div>

            </div>

        </section>

    );
};


export default DescriptionSection;